const showToast = (message, type = 'error') => {
    const toast = document.createElement('div');
    toast.className = 'hk-toast hk-toast--' + type;
    toast.setAttribute('role', 'alert');
    toast.textContent = message;
    Object.assign(toast.style, {
        position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
        padding: '14px 24px', borderRadius: '12px', zIndex: '10000', maxWidth: '90vw',
        fontSize: '15px', fontWeight: '600', lineHeight: '1.4', textAlign: 'center',
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        background: type === 'success' ? '#0f5f70' : '#a12830',
        color: '#fff',
    });
    document.body.appendChild(toast);
    setTimeout(() => { toast.style.opacity = '0'; toast.style.transition = 'opacity .3s'; }, 4000);
    setTimeout(() => toast.remove(), 4400);
};

const trackProfileAction = (submitType, status, extra = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'profile_action_' + submitType,
        comp_core: Object.assign({
            profile_section: 'datos-personales',
            submit_type: submitType,
            status: status,
            via: 'mi-perfil',
            page_url: window.location.href,
        }, extra)
    });
};

const initDisplayerButtons = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') {
        return;
    }

    root.querySelectorAll('.displayer-btn[data-display], .family-member-add-trigger[data-display]').forEach(button => {
        if (button.dataset.hkDisplayerBound === '1') {
            return;
        }

        const resolveScopedDisplayElement = () => {
            const displayId = button.dataset.display || '';
            if (!displayId) {
                return null;
            }

            const localScope = button.closest('[data-hk-profile-fragment-slot="profile-tab-datos-personales"], #datos-personales, .data-content.personal-data, .user-data-section') || root;
            const escapedId = window.CSS && typeof window.CSS.escape === 'function'
                ? window.CSS.escape(displayId)
                : displayId.replace(/[^a-zA-Z0-9_-]/g, '');

            if (localScope && typeof localScope.querySelector === 'function' && escapedId) {
                const localMatch = localScope.querySelector(`#${escapedId}`);
                if (localMatch) {
                    return localMatch;
                }
            }

            return document.getElementById(displayId);
        };

        const syncDisplayerState = () => {
            const displayEl = resolveScopedDisplayElement();
            const isOpen = button.classList.contains('open');

            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

            if (!displayEl) {
                return;
            }

            displayEl.style.visibility = isOpen ? 'visible' : 'hidden';
            displayEl.style.height = isOpen ? 'auto' : '0px';
        };

        button.dataset.hkDisplayerBound = '1';
        syncDisplayerState();

        button.addEventListener('click', event => {
            event.preventDefault();
            button.classList.toggle('open');
            syncDisplayerState();
        });
    });
};

const phonePrefixEmojiMap = {
    'España': '🇪🇸',
    'Mexico': '🇲🇽',
    'México': '🇲🇽',
    'Argentina': '🇦🇷',
    'Colombia': '🇨🇴',
    'Venezuela': '🇻🇪',
    'Estados Unidos': '🇺🇸',
    'United States': '🇺🇸',
    'Albania': '🇦🇱',
    'Alemania': '🇩🇪',
    'Germany': '🇩🇪',
    'Andorra': '🇦🇩',
    'Austria': '🇦🇹',
    'Bélgica': '🇧🇪',
    'Belgica': '🇧🇪',
    'Belgium': '🇧🇪',
    'Bulgaria': '🇧🇬',
    'Croacia': '🇭🇷',
    'Dinamarca': '🇩🇰',
    'Eslovenia': '🇸🇮',
    'Estonia': '🇪🇪',
    'Francia': '🇫🇷',
    'France': '🇫🇷',
    'Italia': '🇮🇹',
    'Italy': '🇮🇹',
    'Portugal': '🇵🇹',
    'Reino Unido': '🇬🇧',
    'United Kingdom': '🇬🇧',
    'Brasil': '🇧🇷',
    'Peru': '🇵🇪',
    'Perú': '🇵🇪',
    'Chile': '🇨🇱',
    'Uruguay': '🇺🇾',
    'Paraguay': '🇵🇾',
    'Bolivia': '🇧🇴',
    'Ecuador': '🇪🇨',
    'Guatemala': '🇬🇹',
    'Honduras': '🇭🇳',
    'El Salvador': '🇸🇻',
    'Panama': '🇵🇦',
    'Panamá': '🇵🇦',
    'Costa Rica': '🇨🇷',
    'Canada': '🇨🇦',
    'Canadá': '🇨🇦',
    'Cuba': '🇨🇺',
};

const phonePrefixCountryByCode = {
    '+1': 'Estados Unidos',
    '+20': 'Egipto',
    '+34': 'España',
    '+44': 'United Kingdom',
    '+49': 'Alemania',
    '+52': 'Mexico',
    '+53': 'Cuba',
    '+54': 'Argentina',
    '+57': 'Colombia',
    '+58': 'Venezuela',
    '+82': 'Corea del Sur',
    '+86': 'China',
    '+212': 'Marruecos',
    '+216': 'Túnez',
    '+225': 'Costa de Marfil',
    '+233': 'Ghana',
    '+235': 'Chad',
    '+242': 'Congo',
    '+243': 'República Democrática del Congo',
    '+269': 'Comoras',
    '+355': 'Albania',
    '+357': 'Chipre',
    '+376': 'Andorra',
    '+379': 'Vaticano',
    '+420': 'República Checa',
    '+506': 'Costa Rica',
    '+850': 'Corea del Norte',
    '+974': 'Qatar',
    '+1767': 'Dominica',
};

const resolvePhonePrefixData = (option, originalLabel) => {
    const matchCode = originalLabel.match(/\(\s*\+?\s*\d+\s*\)/) || originalLabel.match(/\+\d+/);
    let code = matchCode ? matchCode[0].replace(/[()]/g, '').trim() : '';
    if (!code && option.value) {
        code = String(option.value).trim();
    }
    code = code.replace(/\s+/g, '');
    if (code && !code.startsWith('+')) {
        code = '+' + code;
    }

    const rawCountry = originalLabel.includes('(')
        ? originalLabel.split('(')[0].trim()
        : '';
    const country = (rawCountry || phonePrefixCountryByCode[code] || '').replace(/\s+/g, ' ').trim();
    const flag = phonePrefixEmojiMap[country] || '';

    if (country && code) {
        return {
            code,
            country,
            flag,
            fullLabel: `${flag ? `${flag} ` : ''}${country} (${code})`.trim(),
            compactLabel: `${flag ? `${flag} ` : ''}${code}`.trim(),
        };
    }

    if (code) {
        return {
            code,
            country,
            flag,
            fullLabel: `${flag ? `${flag} ` : ''}${code}`.trim(),
            compactLabel: `${flag ? `${flag} ` : ''}${code}`.trim(),
        };
    }

    return {
        code: '',
        country,
        flag,
        fullLabel: originalLabel.trim(),
        compactLabel: originalLabel.trim(),
    };
};

const resolvePhonePrefixPresentation = (option, originalLabel) => {
    return resolvePhonePrefixData(option, originalLabel).fullLabel;
};

const resolvePhonePrefixCompactPresentation = (option, originalLabel) => {
    return resolvePhonePrefixData(option, originalLabel).compactLabel;
};

const createPhonePrefixPart = (className, text) => {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    return span;
};

const renderPhonePrefixTriggerContent = (button, option, originalLabel) => {
    const data = resolvePhonePrefixData(option, originalLabel);
    button.replaceChildren();
    const flagNode = createPhonePrefixPart('hk-phone-prefix-fallback__flag', data.flag || ' ');
    if (!data.flag) {
        flagNode.classList.add('is-empty');
    }
    button.appendChild(flagNode);

    button.appendChild(createPhonePrefixPart('hk-phone-prefix-fallback__compact', data.code || data.compactLabel));
    button.title = data.fullLabel;
};

const renderPhonePrefixOptionContent = (button, option, originalLabel) => {
    const data = resolvePhonePrefixData(option, originalLabel);
    button.replaceChildren();
    button.title = data.fullLabel;
    const flagNode = createPhonePrefixPart('hk-phone-prefix-fallback__flag', data.flag || ' ');
    if (!data.flag) {
        flagNode.classList.add('is-empty');
    }
    button.appendChild(flagNode);

    const text = document.createElement('span');
    text.className = 'hk-phone-prefix-fallback__text';

    if (data.country) {
        text.appendChild(createPhonePrefixPart('hk-phone-prefix-fallback__country', data.country));
    }

    text.appendChild(createPhonePrefixPart('hk-phone-prefix-fallback__code', data.code ? `(${data.code})` : data.fullLabel));
    button.appendChild(text);
};

const decoratePhonePrefixes = () => {
    const selects = document.querySelectorAll('select[name="phone_prefix"], select#phone_prefix');
    if (!selects.length) {
        return;
    }

    selects.forEach(select => {
        Array.from(select.options).forEach(option => {
            const originalLabel = option.dataset.hkOriginalLabel || option.textContent || '';
            if (!option.dataset.hkOriginalLabel) {
                option.dataset.hkOriginalLabel = originalLabel;
            }

            option.textContent = resolvePhonePrefixPresentation(option, originalLabel);
        });
    });
};

const initPhonePrefixChoices = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function' || typeof window.Choices !== 'function') {
        return;
    }

    root.querySelectorAll('select.hk-phone-prefix-select').forEach(select => {
        if (select.dataset.hkPhonePrefixChoicesBound === '1') {
            return;
        }

        try {
            new window.Choices(select, {
                removeItemButton: false,
                itemSelectText: '',
                searchEnabled: false,
                shouldSort: false,
                placeholder: false,
                classNames: {
                    containerInner: 'choices__inner hk-phone-prefix-choices__inner',
                    input: 'choices__input hk-phone-prefix-choices__input',
                    inputCloned: 'choices__input--cloned hk-phone-prefix-choices__input--cloned',
                    listDropdown: 'choices__list--dropdown hk-phone-prefix-choices__dropdown',
                },
            });

            select.dataset.hkPhonePrefixChoicesBound = '1';
            select.classList.add('choices-select');
        } catch (error) {
            console.error('Error inicializando Choices para prefijos telefónicos:', error);
            select.classList.remove('choices-select');
            delete select.dataset.hkPhonePrefixChoicesBound;
        }
    });
};

const closePhonePrefixFallback = (wrapper) => {
    if (!wrapper) {
        return;
    }
    wrapper.classList.remove('is-open');
    const panel = wrapper.querySelector('.hk-phone-prefix-fallback__panel');
    const trigger = wrapper.querySelector('.hk-phone-prefix-fallback__trigger');
    if (panel) {
        panel.hidden = true;
    }
    if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
    }
};

const closeAllPhonePrefixFallbacks = (exceptWrapper = null) => {
    document.querySelectorAll('.hk-phone-prefix-fallback.is-open').forEach(openWrapper => {
        if (openWrapper !== exceptWrapper) {
            closePhonePrefixFallback(openWrapper);
        }
    });
};

const ensurePhonePrefixFallbackDismissHandlers = () => {
    if (window.__hkPhonePrefixFallbackDismissBound) {
        return;
    }
    window.__hkPhonePrefixFallbackDismissBound = '1';

    document.addEventListener('click', event => {
        if (event.target && event.target.closest && event.target.closest('.hk-phone-prefix-fallback')) {
            return;
        }
        closeAllPhonePrefixFallbacks();
    });

    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') {
            return;
        }
        closeAllPhonePrefixFallbacks();
    });
};

const initPhonePrefixFallback = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') {
        return;
    }

    ensurePhonePrefixFallbackDismissHandlers();

    root.querySelectorAll('select.hk-phone-prefix-select').forEach(select => {
        if (select.dataset.hkPhonePrefixChoicesBound === '1' || select.dataset.hkPhonePrefixFallbackBound === '1') {
            return;
        }

        const options = Array.from(select.options).filter(option => String(option.value || '').trim() !== '');
        if (options.length === 0) {
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'hk-phone-prefix-fallback';

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'hk-phone-prefix-fallback__trigger';
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');

        const panel = document.createElement('div');
        panel.className = 'hk-phone-prefix-fallback__panel';
        panel.hidden = true;
        panel.setAttribute('role', 'listbox');

        const syncFromSelect = () => {
            const currentOption = select.options[select.selectedIndex] || options[0];
            if (currentOption) {
                renderPhonePrefixTriggerContent(
                    trigger,
                    currentOption,
                    currentOption.dataset.hkOriginalLabel || currentOption.textContent || ''
                );
            } else {
                trigger.textContent = '';
            }

            Array.from(panel.querySelectorAll('.hk-phone-prefix-fallback__option')).forEach(button => {
                button.classList.toggle('is-selected', button.dataset.value === String(select.value || ''));
            });
        };

        const closePanel = () => {
            closePhonePrefixFallback(wrapper);
        };

        const openPanel = () => {
            wrapper.classList.add('is-open');
            panel.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
        };

        options.forEach(option => {
            const optionButton = document.createElement('button');
            optionButton.type = 'button';
            optionButton.className = 'hk-phone-prefix-fallback__option';
            optionButton.setAttribute('role', 'option');
            optionButton.dataset.value = String(option.value || '');
            renderPhonePrefixOptionContent(
                optionButton,
                option,
                option.dataset.hkOriginalLabel || option.textContent || ''
            );
            optionButton.addEventListener('click', () => {
                select.value = String(option.value || '');
                select.dispatchEvent(new Event('change', { bubbles: true }));
                syncFromSelect();
                closePanel();
                trigger.focus();
            });
            panel.appendChild(optionButton);
        });

        trigger.addEventListener('click', event => {
            event.preventDefault();
            if (wrapper.classList.contains('is-open')) {
                closePanel();
                return;
            }

            closeAllPhonePrefixFallbacks(wrapper);
            openPanel();
        });

        select.dataset.hkPhonePrefixFallbackBound = '1';
        select.classList.add('hk-phone-prefix-select--fallback');

        wrapper.appendChild(trigger);
        wrapper.appendChild(panel);
        select.insertAdjacentElement('afterend', wrapper);

        select.addEventListener('change', syncFromSelect);
        syncFromSelect();
        closePanel();
    });
};

const createProfileMultiSelectLabel = (select) => {
    const htmlLang = (document.documentElement.lang || '').toLowerCase();
    const isSpanish = htmlLang === '' || htmlLang.startsWith('es');
    const selectedOptions = Array.from(select.options).filter(option => option.selected);

    if (selectedOptions.length === 0) {
        return isSpanish ? 'Selecciona una o varias opciones' : 'Select one or more options';
    }

    if (selectedOptions.length <= 2) {
        return selectedOptions.map(option => option.textContent.trim()).join(', ');
    }

    return isSpanish
        ? `${selectedOptions.length} opciones seleccionadas`
        : `${selectedOptions.length} options selected`;
};

const closeProfileMultiSelect = (wrapper) => {
    if (!wrapper) {
        return;
    }
    wrapper.classList.remove('is-open');
    const trigger = wrapper.querySelector('.hk-multi-select__trigger');
    const panel = wrapper.querySelector('.hk-multi-select__panel');
    if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
    }
    if (panel) {
        panel.hidden = true;
    }
};

const closeAllProfileMultiSelects = (exceptWrapper = null) => {
    document.querySelectorAll('.hk-multi-select.is-open').forEach(openWrapper => {
        if (openWrapper !== exceptWrapper) {
            closeProfileMultiSelect(openWrapper);
        }
    });
};

const ensureProfileMultiSelectDismissHandlers = () => {
    if (window.__hkProfileMultiSelectDismissBound) {
        return;
    }
    window.__hkProfileMultiSelectDismissBound = '1';

    document.addEventListener('click', event => {
        if (event.target && event.target.closest && event.target.closest('.hk-multi-select')) {
            return;
        }
        closeAllProfileMultiSelects();
    });

    document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') {
            return;
        }
        closeAllProfileMultiSelects();
    });
};

const normalizeProfileMultiSelectArtifacts = (select) => {
    if (!select) {
        return null;
    }

    const existingChoicesContainer = select.closest('.choices');
    if (existingChoicesContainer && existingChoicesContainer.contains(select) && existingChoicesContainer.parentNode) {
        existingChoicesContainer.parentNode.insertBefore(select, existingChoicesContainer);
        existingChoicesContainer.remove();
        select.removeAttribute('tabindex');
        select.removeAttribute('aria-hidden');
        select.style.display = '';
    }

    const parent = select.parentNode;
    if (!parent) {
        return null;
    }

    const siblingWrappers = Array.from(parent.children).filter(child => {
        return child !== select && child.classList && child.classList.contains('hk-multi-select');
    });

    let primaryWrapper = null;
    siblingWrappers.forEach(wrapper => {
        if (!primaryWrapper && wrapper.previousElementSibling === select) {
            primaryWrapper = wrapper;
            return;
        }

        if (wrapper.previousElementSibling === select || wrapper.nextElementSibling === select) {
            wrapper.remove();
        }
    });

    return primaryWrapper;
};

const initProfileMultiSelects = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') {
        return;
    }

    ensureProfileMultiSelectDismissHandlers();

    root.querySelectorAll('select.choices-select[multiple]').forEach(select => {
        const existingCustomWrapper = normalizeProfileMultiSelectArtifacts(select);

        if (select.dataset.hkMultiSelectBound === '1') {
            if (existingCustomWrapper) {
                return;
            }

            delete select.dataset.hkMultiSelectBound;
            if (select.dataset.hkChoicesBound === 'profile-multiselect') {
                delete select.dataset.hkChoicesBound;
            }
            select.classList.remove('is-enhanced-by-profile');
        }

        const options = Array.from(select.options);
        if (options.length === 0) {
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'hk-multi-select';

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'hk-multi-select__trigger';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'listbox');

        const triggerLabel = document.createElement('span');
        triggerLabel.className = 'hk-multi-select__value';
        trigger.appendChild(triggerLabel);

        const triggerIcon = document.createElement('span');
        triggerIcon.className = 'hk-multi-select__icon';
        triggerIcon.setAttribute('aria-hidden', 'true');
        triggerIcon.textContent = '+';
        trigger.appendChild(triggerIcon);

        const panel = document.createElement('div');
        panel.className = 'hk-multi-select__panel';
        panel.hidden = true;
        panel.setAttribute('role', 'listbox');
        panel.setAttribute('aria-multiselectable', 'true');

        const updateSummary = () => {
            const label = createProfileMultiSelectLabel(select);
            const hasValue = Array.from(select.options).some(option => option.selected);
            triggerLabel.textContent = label;
            wrapper.classList.toggle('is-empty', !hasValue);
        };

        const syncFromSelect = () => {
            panel.querySelectorAll('.hk-multi-select__option input').forEach(input => {
                const option = options.find(entry => entry.value === input.value);
                input.checked = !!(option && option.selected);
            });
            updateSummary();
        };

        const openPanel = () => {
            wrapper.classList.add('is-open');
            panel.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
        };

        const closePanel = () => {
            closeProfileMultiSelect(wrapper);
        };

        options.forEach((option, index) => {
            const label = document.createElement('label');
            label.className = 'hk-multi-select__option';
            label.setAttribute('role', 'option');
            label.setAttribute('aria-selected', option.selected ? 'true' : 'false');

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.value = option.value;
            checkbox.checked = option.selected;
            checkbox.tabIndex = -1;

            const text = document.createElement('span');
            text.className = 'hk-multi-select__option-label';
            text.textContent = option.textContent.trim();

            checkbox.addEventListener('change', () => {
                option.selected = checkbox.checked;
                label.setAttribute('aria-selected', checkbox.checked ? 'true' : 'false');
                updateSummary();
                select.dispatchEvent(new Event('change', { bubbles: true }));
            });

            label.appendChild(checkbox);
            label.appendChild(text);
            panel.appendChild(label);

            if (index === 0) {
                label.dataset.hkFirstOption = '1';
            }
        });

        trigger.addEventListener('click', event => {
            event.preventDefault();
            if (wrapper.classList.contains('is-open')) {
                closePanel();
                return;
            }

            closeAllProfileMultiSelects(wrapper);
            openPanel();
        });

        select.classList.add('is-enhanced-by-profile');
        select.dataset.hkChoicesBound = 'profile-multiselect';
        select.dataset.hkMultiSelectBound = '1';

        wrapper.appendChild(trigger);
        wrapper.appendChild(panel);
        select.insertAdjacentElement('afterend', wrapper);

        select.addEventListener('change', syncFromSelect);
        syncFromSelect();
    });
};

const initMyHakunaPersonalDataSection = () => {
    const personalDataRoot = document.querySelector('[data-hk-profile-fragment-slot="profile-tab-datos-personales"]') || document;

    initDisplayerButtons(personalDataRoot);
    initProfileMultiSelects(personalDataRoot);
    decoratePhonePrefixes();
    initPhonePrefixChoices(personalDataRoot);
    initPhonePrefixFallback(personalDataRoot);
    profileForm();
    profileImage();
    familyForm();
    fillCities();
    payOutstandingPayments();

    // ---- Progreso de my-hakuna-form ----
    const myHakunaForm = document.getElementById('my-hakuna-form');
    if (myHakunaForm) {
        const campos = myHakunaForm.querySelectorAll('input, select, textarea');
        let total = 0;
        let completos = 0;

        campos.forEach(campo => {
            // Ignora campos ocultos y de tipo submit/reset/button/search
            if (['hidden', 'submit', 'reset', 'button', 'search'].includes(campo.type)) return;

            total++;
            if (campo.value.trim() !== '') {
                completos++;
            }
        });

        const porcentaje = total > 0 ? Math.round((completos / total) * 100) : 0;

        const progressFill = document.getElementById('progress-fill');
        const progressPercentage = document.getElementById('progress-percentage');

        if (progressFill) {
            progressFill.style.width = porcentaje + '%';
        }
        if (progressPercentage) {
            progressPercentage.textContent = porcentaje + '%';
        }

        const progressBar = myHakunaForm.closest('.data-content.personal-data')?.querySelector('.user-progress-bar');
        if (progressBar) {
            progressBar.classList.toggle('is-complete', porcentaje >= 100);
        }
    }

    // ---- Toggle acceso web en family-form ----
    const familyFormEl = document.getElementById('family-form');
    const familyWebAccessToggle = document.getElementById('family-new-user-toggle');
    const familyWebAccessValue = document.getElementById('family-new-user-value');
    const familyWebAccessState = document.getElementById('family-new-user-state');
    const emailWrapper = document.getElementById('email-wrapper');
    const emailInput = document.getElementById('family-member-email');
    const familyBirthdateInput = document.getElementById('Birthdate');
    const familyAccessBlock = document.getElementById('family-web-access-block');
    const familyAccessStatus = document.getElementById('family-web-access-status');

    if (familyFormEl && familyWebAccessToggle && familyWebAccessValue && familyWebAccessState && emailWrapper && emailInput && familyBirthdateInput) {
        const nifInput = document.getElementById('HKN_NIF__c');
        const ageGroupInput = document.getElementById('family-member-age-group');
        const phonePrefixInput = document.getElementById('family-member-phone-prefix');
        const phoneInput = document.getElementById('family-member-phone');
        const adultFieldsSection = document.getElementById('family-adult-fields');
        const adultFieldsHint = document.getElementById('family-adult-fields-hint');
        const adultOnlyFields = [nifInput, ageGroupInput, phonePrefixInput, phoneInput].filter(Boolean);

        if (typeof familyFormEl._hkUpdateFamilyWebAccess === 'function') {
            familyWebAccessToggle.removeEventListener('change', familyFormEl._hkUpdateFamilyWebAccess);
        }

        if (typeof familyFormEl._hkUpdateFamilyBirthdate === 'function') {
            familyBirthdateInput.removeEventListener('change', familyFormEl._hkUpdateFamilyBirthdate);
        }

        if (typeof familyFormEl._hkCheckEmailListener === 'function' && emailInput) {
            emailInput.removeEventListener('blur', familyFormEl._hkCheckEmailListener);
            emailInput.removeEventListener('input', familyFormEl._hkCheckEmailListener);
        }

        if (!familyFormEl._hkEmailPlaceholder && emailWrapper.parentNode) {
            const placeholder = document.createComment('email-placeholder');
            emailWrapper.parentNode.insertBefore(placeholder, emailWrapper.nextSibling);
            familyFormEl._hkEmailPlaceholder = placeholder;
        }

        const placeholder = familyFormEl._hkEmailPlaceholder;
        const getFamilyAge = () => {
            const rawValue = (familyBirthdateInput.value || '').trim();
            if (!rawValue) {
                return null;
            }

            const birthdate = new Date(`${rawValue}T00:00:00`);
            if (Number.isNaN(birthdate.getTime())) {
                return null;
            }

            const today = new Date();
            let age = today.getFullYear() - birthdate.getFullYear();
            const monthDelta = today.getMonth() - birthdate.getMonth();
            if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthdate.getDate())) {
                age -= 1;
            }

            return age;
        };

        const hideAccessStatus = () => {
            if (!familyAccessStatus) return;
            familyAccessStatus.hidden = true;
            familyAccessStatus.textContent = '';
            familyAccessStatus.dataset.status = '';
        };

        const renderAccessStatus = (status, message) => {
            if (!familyAccessStatus) return;
            if (!status || !message) {
                hideAccessStatus();
                return;
            }
            familyAccessStatus.hidden = false;
            familyAccessStatus.textContent = message;
            familyAccessStatus.dataset.status = status;
        };

        const checkExistingAccount = () => {
            if (!familyAccessStatus) return;
            const email = (emailInput.value || '').trim();
            const firstName = String(document.getElementById('FirstName')?.value || '').trim();
            const lastName = String(document.getElementById('LastName')?.value || '').trim();
            const birthdate = String(familyBirthdateInput?.value || '').trim();
            const nif = String(document.getElementById('HKN_NIF__c')?.value || '').trim();
            const hasValidEmail = email !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            const hasIdentity = firstName !== '' && lastName !== '' && birthdate !== '';
            if (!familyWebAccessToggle.checked || (!hasValidEmail && !hasIdentity && nif === '')) {
                hideAccessStatus();
                return;
            }

            const restRoot = (typeof admin !== 'undefined' && admin && admin.rest_url) ? admin.rest_url : '/wp-json/';
            const url = restRoot.replace(/\/$/, '') + '/hk-extras/v1/family/check-web-account';
            const formNonce = (familyFormEl.querySelector('input[name="_wpnonce"]') || {}).value || '';
            const body = new FormData();
            if (hasValidEmail) body.append('email', email);
            if (firstName) body.append('first_name', firstName);
            if (lastName) body.append('last_name', lastName);
            if (birthdate) body.append('birthdate', birthdate);
            if (nif) body.append('nif', nif);
            body.append('nonce', formNonce);

            renderAccessStatus('checking', admin?.text?.familyAccessChecking || 'Comprobando si esta persona ya tiene cuenta…');

            fetch(url, {
                method: 'POST',
                credentials: 'same-origin',
                body,
            })
                .then((response) => response.json().catch(() => null))
                .then((data) => {
                    if (!data || typeof data.status !== 'string') {
                        hideAccessStatus();
                        return;
                    }
                    renderAccessStatus(data.status, data.message || '');
                })
                .catch(() => {
                    hideAccessStatus();
                });
        };

        let checkDebounce = null;
        const queueExistingAccountCheck = () => {
            if (checkDebounce) {
                clearTimeout(checkDebounce);
            }
            checkDebounce = setTimeout(checkExistingAccount, 350);
        };

        const familyRoleSelect = document.getElementById('family-member-family-role');
        const familyRoleSpouseOption = familyRoleSelect
            ? Array.from(familyRoleSelect.options).find((opt) => String(opt.value || '').toLowerCase() === 'cónyuge'.toLowerCase() || String(opt.value || '').toLowerCase() === 'conyuge')
            : null;

        // Aviso accesible junto al selector de relación: se usa cuando una
        // fecha de menor obliga a cambiar Cónyuge → Hijo/a, para que el
        // cambio no sea silencioso. Se crea bajo demanda y se reutiliza.
        let familyRoleHintEl = null;
        const setFamilyRoleHint = (text) => {
            if (!familyRoleSelect) {
                return;
            }
            if (!text) {
                if (familyRoleHintEl) {
                    familyRoleHintEl.hidden = true;
                    familyRoleHintEl.textContent = '';
                }
                return;
            }
            if (!familyRoleHintEl) {
                familyRoleHintEl = document.createElement('p');
                familyRoleHintEl.className = 'hk-family-role-hint';
                familyRoleHintEl.setAttribute('role', 'status');
                familyRoleHintEl.setAttribute('aria-live', 'polite');
                familyRoleHintEl.style.cssText = 'margin:6px 0 0;font-size:0.85em;color:#b54708;';
                const wrapper = familyRoleSelect.closest('#family-role-wrapper') || familyRoleSelect.parentElement;
                if (wrapper) {
                    wrapper.appendChild(familyRoleHintEl);
                }
            }
            familyRoleHintEl.textContent = text;
            familyRoleHintEl.hidden = false;
        };

        const syncFamilyRoleByAge = (isAdult, knowsAge) => {
            if (!familyRoleSelect || !familyRoleSpouseOption) {
                return;
            }
            // Menor confirmado: solo puede ser "Hijo/a"; ocultamos la opción de
            // Cónyuge y forzamos el valor avisando del cambio. Sin fecha de
            // nacimiento todavía, el dropdown queda completo para no bloquear
            // "Marido / mujer" al abrir el formulario (la relación es el primer
            // campo que toca el usuario).
            if (knowsAge && !isAdult) {
                familyRoleSpouseOption.disabled = true;
                familyRoleSpouseOption.hidden = true;
                if (familyRoleSelect.value !== 'Hijo') {
                    familyRoleSelect.value = 'Hijo';
                    setFamilyRoleHint(admin?.text?.familyRoleMinorHint
                        || 'Un menor de edad solo puede añadirse como Hijo/a, así que hemos cambiado la relación.');
                }
            } else {
                familyRoleSpouseOption.disabled = false;
                familyRoleSpouseOption.hidden = false;
                setFamilyRoleHint('');
            }
        };

        const updateFamilyWebAccess = () => {
            const memberAge = getFamilyAge();
            const knowsAge = typeof memberAge === 'number';
            const isAdult = knowsAge && memberAge >= 18;
            // Solo los mayores de edad pueden tener cuenta propia en la web.
            // Para menores: el toggle se fuerza a off y se oculta visualmente,
            // para que el flujo de invitación + WP user nunca se dispare.
            if (!isAdult && familyWebAccessToggle.checked) {
                familyWebAccessToggle.checked = false;
            }
            // Y el selector Hijo/Cónyuge: para menores confirmados solo cabe "Hijo".
            syncFamilyRoleByAge(isAdult, knowsAge);
            const hasWebAccess = isAdult && !!familyWebAccessToggle.checked;
            const needsEmail = hasWebAccess || isAdult;
            familyWebAccessToggle.disabled = !isAdult;
            familyWebAccessValue.value = hasWebAccess ? 'yes' : 'no';
            familyWebAccessState.textContent = hasWebAccess
                ? (admin?.text?.familyYes || 'Sí')
                : (admin?.text?.familyNo || 'No');

            if (familyAccessBlock) {
                familyAccessBlock.hidden = !isAdult;
                familyAccessBlock.dataset.ageMode = knowsAge ? (isAdult ? 'adult' : 'minor') : 'unknown';
            }

            adultOnlyFields.forEach((field) => {
                field.required = isAdult;
                field.setAttribute('aria-required', isAdult ? 'true' : 'false');
            });

            if (adultFieldsSection) {
                let ageMode = 'unknown';
                if (knowsAge) {
                    ageMode = isAdult ? 'adult' : 'minor';
                }
                adultFieldsSection.dataset.ageMode = ageMode;
            }

            if (adultFieldsHint) {
                if (!knowsAge) {
                    adultFieldsHint.textContent = admin?.text?.familyAdultHintPending || 'Rellena la fecha de nacimiento para saber qué datos son obligatorios.';
                } else if (isAdult) {
                    adultFieldsHint.textContent = admin?.text?.familyAdultHintAdult || 'Para mayores de edad pedimos ID fiscal/nacional, grupo de edad, prefijo, teléfono y correo.';
                } else {
                    adultFieldsHint.textContent = admin?.text?.familyAdultHintMinor || 'Si es menor de edad, estos datos pueden quedar vacíos por ahora.';
                }
            }

            if (needsEmail) {
                if (!emailWrapper.parentNode && placeholder && placeholder.parentNode) {
                    placeholder.parentNode.insertBefore(emailWrapper, placeholder.nextSibling);
                }
                emailWrapper.hidden = false;
                emailInput.required = true;
            } else {
                emailWrapper.hidden = true;
                emailInput.required = false;
            }

            if (!isAdult || !familyWebAccessToggle.checked) {
                hideAccessStatus();
                return;
            }
            queueExistingAccountCheck();
        };

        updateFamilyWebAccess();
        familyWebAccessToggle.addEventListener('change', updateFamilyWebAccess);
        familyBirthdateInput.addEventListener('change', updateFamilyWebAccess);
        // 'input' cubre autofill y date-pickers que no disparan 'change'.
        familyBirthdateInput.addEventListener('input', updateFamilyWebAccess);
        if (familyRoleSelect) {
            // Re-sincroniza si el navegador restaura/auto-rellena el select.
            familyRoleSelect.addEventListener('change', updateFamilyWebAccess);
        }
        const onEmailChange = () => {
            if (familyWebAccessToggle.checked) {
                queueExistingAccountCheck();
            }
        };
        emailInput.addEventListener('blur', onEmailChange);
        emailInput.addEventListener('input', onEmailChange);
        familyFormEl._hkUpdateFamilyWebAccess = updateFamilyWebAccess;
        familyFormEl._hkUpdateFamilyBirthdate = updateFamilyWebAccess;
        familyFormEl._hkCheckEmailListener = onEmailChange;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initMyHakunaPersonalDataSection();

    const submitEditForm = (url, hiddenFields) => {
        if (!url) {
            return;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;

        Object.entries(hiddenFields).forEach(([name, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
    };

    document.addEventListener('click', event => {
        const donationButton = event.target.closest('.open-donation');
        if (donationButton) {
            event.preventDefault();
            submitEditForm(donationButton.dataset.url, {
                donation_id: donationButton.dataset.donation || '',
                edit_donation: 'true',
            });
            return;
        }

        const suscriptionButton = event.target.closest('.open-suscription');
        if (suscriptionButton) {
            event.preventDefault();
            submitEditForm(suscriptionButton.dataset.url, {
                suscription_id: suscriptionButton.dataset.suscription || '',
                edit_suscription: 'true',
            });
            return;
        }

        const reactivationButton = event.target.closest('.open-suscription-reactivate');
        if (reactivationButton) {
            event.preventDefault();
            submitEditForm(reactivationButton.dataset.url, {
                suscription_id: reactivationButton.dataset.suscription || '',
                reactivate_suscription: 'true',
            });
        }
    });
});

document.addEventListener('hk:profile-fragment-loaded', (event) => {
    const detail = event && event.detail ? event.detail : {};
    if ((detail.name || '') === 'profile-tab-datos-personales') {
        initMyHakunaPersonalDataSection();
    }
    if ((detail.name || '') === 'profile-global-notices') {
        payOutstandingPayments();
    }
});

window.addEventListener('load', () => {
    goToTab();
});

const familyMembersUpdatedStorageKey = 'hk_family_members_updated';
const notifyFamilyMembersUpdated = () => {
    try {
        localStorage.setItem(familyMembersUpdatedStorageKey, String(Date.now()));
    } catch (error) {
        // localStorage can be blocked in some contexts.
    }
};


const fillCities = () => {
    const countryInput = document.getElementById('country');
    const cityInput = document.getElementById('state');
    const countryCodeInput = document.getElementById('MailingCountryCode');
    if (!countryInput || !cityInput) {
        return;
    }
    if (countryInput.dataset.hkCitiesBound === '1') {
        return;
    }

    countryInput.dataset.hkCitiesBound = '1';

    const syncStateField = (cities = [], selectedValue = '') => {
        const hasCities = Array.isArray(cities) && cities.length > 0;
        const requiredPlaceholder = cityInput.dataset.placeholderRequired || 'Select your state';
        const optionalPlaceholder = cityInput.dataset.placeholderOptional || 'No state/province required';
        const currentSelectedValue = (selectedValue || '').trim();

        cityInput.innerHTML = '';
        cityInput.required = hasCities;
        cityInput.setAttribute('aria-required', hasCities ? 'true' : 'false');

        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = hasCities ? requiredPlaceholder : optionalPlaceholder;
        defaultOption.disabled = hasCities;
        defaultOption.selected = currentSelectedValue === '';
        cityInput.appendChild(defaultOption);

        if (!hasCities) {
            if (currentSelectedValue) {
                const fallbackOption = document.createElement('option');
                fallbackOption.value = currentSelectedValue;
                fallbackOption.textContent = currentSelectedValue;
                fallbackOption.selected = true;
                fallbackOption.dataset.hkRetained = '1';
                cityInput.appendChild(fallbackOption);
            }
            return;
        }

        cities.forEach((city) => {
            const option = document.createElement('option');
            option.value = city.value;
            option.textContent = city.label;
            cityInput.appendChild(option);
        });

        if (currentSelectedValue) {
            let matchingStateOption = Array.from(cityInput.options).find((option) => {
                return option && option.value === currentSelectedValue;
            });

            if (!matchingStateOption) {
                matchingStateOption = document.createElement('option');
                matchingStateOption.value = currentSelectedValue;
                matchingStateOption.textContent = currentSelectedValue;
                matchingStateOption.dataset.hkRetained = '1';
                cityInput.appendChild(matchingStateOption);
            }

            matchingStateOption.selected = true;
        }
    };

    const syncCountryCode = () => {
        const selectedOption = countryInput.options[countryInput.selectedIndex];
        const selectedCountryCode = selectedOption && selectedOption.dataset ? String(selectedOption.dataset.country || '').trim() : '';
        if (selectedCountryCode) {
            if (countryCodeInput) {
                countryCodeInput.value = selectedCountryCode;
            }
            return selectedCountryCode;
        }

        const currentCountryCode = countryCodeInput ? (countryCodeInput.value || '').trim() : '';
        if (!currentCountryCode) {
            return '';
        }

        const matchingOption = Array.from(countryInput.options).find((option) => {
            return option && option.dataset && option.dataset.country === currentCountryCode;
        });
        if (matchingOption) {
            countryInput.value = matchingOption.value;
        }
        return currentCountryCode;
    };

    const loadCities = (countryCode, preserveCurrentState = false) => {
        const normalizedCountryCode = (countryCode || '').trim();
        const currentStateValue = preserveCurrentState ? (cityInput.value || '').trim() : '';
        if (!normalizedCountryCode) {
            syncStateField([], currentStateValue);
            return;
        }

        fetch(admin.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'get_cities_by_country',
                country_code: normalizedCountryCode,
            }),
        })
            .then((response) => response.json())
            .then((result) => {
                const cities = result && result.success && result.data && Array.isArray(result.data.cities)
                    ? result.data.cities
                    : [];
                syncStateField(cities, currentStateValue);
            })
            .catch((error) => {
                console.error('Error fetching cities:', error);
                syncStateField([], currentStateValue);
            });
    };

    const initialCountryCode = syncCountryCode();
    const initialStateValue = (cityInput.value || '').trim();
    if (initialCountryCode && (!initialStateValue || cityInput.options.length <= 1)) {
        loadCities(initialCountryCode, true);
    }

    countryInput.addEventListener('change', () => {
        const countryCodeForFetch = syncCountryCode();
        if (!countryCodeForFetch) {
            syncStateField([]);
            return;
        }

        loadCities(countryCodeForFetch, false);
    });
}

const profileImage = () => {
    const profileInput = document.getElementById('profile_image');
    const preview = document.getElementById('profile_image_preview');
    const uploadButton = document.getElementById('upload_button');

    if (!profileInput || !preview || !uploadButton) {
        return;
    }
    if (uploadButton.dataset.hkProfileImageBound === '1' || profileInput.dataset.hkProfileImageBound === '1') {
        return;
    }

    uploadButton.dataset.hkProfileImageBound = '1';
    profileInput.dataset.hkProfileImageBound = '1';

    uploadButton.addEventListener('click', () => {
        profileInput.click()
    })

    if( profileInput ) {
        profileInput.addEventListener( 'change', ( event ) => {
            const file = event.target.files[0];
            if( !file ) return

            const formData = new FormData()
            formData.append( 'action', 'upload_profile_image' )
            formData.append( 'profile_image', file )
            formData.append('user_id', document.getElementById('user_id').value)

            const xhr = new XMLHttpRequest()

            xhr.open('POST', admin.ajax_wp, true)
            xhr.onload = () => {
                if( 200 === xhr.status ) {
                    const response = JSON.parse(xhr.responseText)
                    if (response.success) {
                        preview.innerHTML = '<img src="' + response.data.image_url + '" alt="Imagen de perfil">'
                    } else {
                        showToast('Hubo un error al subir la imagen: ' + response.data.message);
                    }
                } else {
                    showToast('Error en la subida de la imagen.')
                }
            }
            xhr.send(formData)
        })
    }
}

const showUpdateErrorNotice = (message) => {
    const ko = document.getElementById('update-ko');
    if (!ko) {
        return;
    }

    const fallbackMessage = 'No se pudieron guardar los cambios. Reintenta.';
    const finalMessage = (typeof message === 'string' && message.trim() !== '')
        ? message.trim()
        : fallbackMessage;
    const noticeMessage = ko.querySelector('.notice-content p');

    ko.style.visibility = "visible";
    ko.style.height = "inherit";
    ko.style.columnGap = "10px";
    ko.style.padding = "16px";
    ko.style.marginTop = "16px";

    if (noticeMessage) {
        noticeMessage.textContent = finalMessage;
        return;
    }

    ko.textContent = finalMessage;
}

const profileForm = () => {
    const myHakunaForm = document.getElementById( 'my-hakuna-form' )
    if (!myHakunaForm || myHakunaForm.dataset.hkProfileFormBound === '1') {
        return;
    }

    myHakunaForm.dataset.hkProfileFormBound = '1';

    const submitButtons = Array.from(myHakunaForm.querySelectorAll('button[type="submit"], input[type="submit"]'));
    const setSubmittingState = (isSubmitting) => {
        myHakunaForm.dataset.hkSubmitting = isSubmitting ? '1' : '0';
        submitButtons.forEach((submitButton) => {
            submitButton.disabled = isSubmitting;
        });
    };

    myHakunaForm.addEventListener('submit', (e) => {
        e.preventDefault();
        if (myHakunaForm.dataset.hkSubmitting === '1') {
            return;
        }

        const countryInput = document.getElementById('country');
        const countryCodeInput = document.getElementById('MailingCountryCode');
        if (countryInput && countryCodeInput) {
            const selectedOption = countryInput.options[countryInput.selectedIndex];
            const selectedCountryCode = selectedOption && selectedOption.dataset ? selectedOption.dataset.country : '';
            if (selectedCountryCode) {
                countryCodeInput.value = selectedCountryCode;
            } else {
                const currentCountryCode = (countryCodeInput.value || '').trim();
                if (currentCountryCode) {
                    countryCodeInput.value = currentCountryCode;
                }
            }
        }

        const formData = new FormData(myHakunaForm);
        const updateOk = document.getElementById('update-ok');
        const updateKo = document.getElementById('update-ko');
        if (updateOk) {
            updateOk.style.visibility = "hidden";
        }
        if (updateKo) {
            updateKo.style.visibility = "hidden";
        }

        setSubmittingState(true);

        fetch(admin.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.json();
        })
        .then(result => {
            const updateCode = (result && typeof result.code !== 'undefined')
                ? result.code
                : (result && result.data && typeof result.data.code !== 'undefined' ? result.data.code : null);
            const message = (result && result.data && typeof result.data.message !== 'undefined')
                ? result.data.message
                : (result && typeof result.message !== 'undefined' ? result.message : 'No se pudieron guardar los cambios. Reintenta.');

            if (parseInt(updateCode, 10) === 204) {
                trackProfileAction('update_personal_data', 'ok');
                if (updateOk) {
                    updateOk.style.visibility = "visible";
                    updateOk.style.height = "inherit";
                    updateOk.style.columnGap = "10px";
                    updateOk.style.padding = "16px";
                    updateOk.style.marginTop = "16px";
                }
                setTimeout(() => {
                    const redirectUrl = new URL(admin.urlredirect, window.location.origin);
                    redirectUrl.searchParams.delete('profile_updated');
                    redirectUrl.searchParams.set('hk_subpage', 'datos-personales');
                    redirectUrl.searchParams.delete('subpage');
                    redirectUrl.searchParams.delete('tab');
                    window.location.href = redirectUrl.toString();
                }, 1000);
            } else {
                trackProfileAction('update_personal_data', 'ko');
                setSubmittingState(false);
                showUpdateErrorNotice(message);
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        })
        .catch((error) => {
            trackProfileAction('update_personal_data', 'ko', { via: 'network' });
            setSubmittingState(false);
            showUpdateErrorNotice(error && error.message
                ? `${error.message}. Contacta con soporte si el error persiste.`
                : 'No se pudieron guardar los cambios. Reintenta.');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            console.error('Error al actualizar el perfil:', error);
        });
    });
};

const restoreFamilySubmitButton = () => {
    const submitButton = document.getElementById('submit-family');
    if (!submitButton) {
        return;
    }

    submitButton.disabled = false;

    const originalText = submitButton.dataset.originalText;
    if (typeof originalText !== 'undefined') {
        if (submitButton.tagName.toLowerCase() === 'input') {
            submitButton.value = originalText;
        } else {
            submitButton.innerText = originalText;
        }
    }

    const originalBackground = submitButton.dataset.originalBackground;
    submitButton.style.background = originalBackground || '';
};

const setFamilySubmitButtonText = (text) => {
    const submitButton = document.getElementById('submit-family');
    if (!submitButton) {
        return;
    }
    if (submitButton.tagName.toLowerCase() === 'input') {
        submitButton.value = text;
        return;
    }
    submitButton.innerText = text;
};

const setFamilyCancelEditVisibility = (visible) => {
    const cancelEditButton = document.getElementById('family-cancel-edit');
    if (!cancelEditButton) {
        return;
    }
    cancelEditButton.style.display = visible ? 'inline-flex' : 'none';
};

const clearFamilyFormNoticeActions = () => {
    const errorNotice = document.getElementById('error-notice');
    if (!errorNotice) {
        return;
    }
    const actions = errorNotice.querySelector('.family-duplicate-actions');
    if (actions) {
        actions.remove();
    }
};

const hideFamilyFormNotice = () => {
    const errorNotice = document.getElementById('error-notice');
    const errorMessage = document.getElementById('error-notice-msg');
    if (!errorNotice) {
        return;
    }

    clearFamilyFormNoticeActions();
    errorNotice.classList.remove('family-duplicate-notice');
    errorNotice.classList.remove('hk-family-notice--confirm');
    errorNotice.style.display = 'none';
    errorNotice.style.height = '';
    errorNotice.style.columnGap = '';
    errorNotice.style.padding = '';
    errorNotice.style.marginTop = '';

    if (errorMessage) {
        errorMessage.textContent = '';
    }
};

const showFamilyFormNotice = (message, tone = 'error') => {
    const errorNotice = document.getElementById('error-notice');
    const errorMessage = document.getElementById('error-notice-msg');
    const fallbackMessage = 'No se pudo completar la operación. Reintenta.';

    if (errorMessage) {
        errorMessage.textContent = (typeof message === 'string' && message.trim() !== '')
            ? message
            : fallbackMessage;
    }

    if (errorNotice) {
        clearFamilyFormNoticeActions();
        errorNotice.classList.toggle('family-duplicate-notice', tone === 'duplicate');
        errorNotice.classList.toggle('hk-family-notice--confirm', tone === 'duplicate');
        errorNotice.style.height = "inherit";
        errorNotice.style.columnGap = "10px";
        errorNotice.style.padding = "16px";
        errorNotice.style.marginTop = "16px";
        errorNotice.style.display = "block";
    }
};

const showFamilyFormError = (message) => {
    showFamilyFormNotice(message, 'error');
};

const showFamilyDuplicateNotice = (message, onConfirm, onCancel) => {
    const errorNotice = document.getElementById('error-notice');
    const noticeContent = errorNotice ? errorNotice.querySelector('.notice-content') : null;
    const question = (typeof message === 'string' && message.trim() !== '')
        ? message
        : (admin?.text?.addexistingmember || 'This member is already registered. Add to the family?');

    showFamilyFormNotice(question, 'duplicate');

    if (!noticeContent) {
        // Fallback: create a minimal notice-content container so inline buttons render.
        const fallbackContent = document.createElement('div');
        fallbackContent.className = 'notice-content';
        if (errorNotice) {
            errorNotice.appendChild(fallbackContent);
        } else {
            onCancel();
            return;
        }
        showFamilyDuplicateNotice(message, onConfirm, onCancel);
        return;
    }

    const actions = document.createElement('div');
    actions.className = 'family-duplicate-actions hk-family-confirm-actions';

    const confirmButton = document.createElement('button');
    confirmButton.type = 'button';
    confirmButton.className = 'button button-primary family-duplicate-action family-duplicate-action--confirm hk-family-confirm-actions__accept';
    confirmButton.textContent = admin?.text?.familyDuplicateConfirm || 'Add to family';

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'button family-duplicate-action family-duplicate-action--cancel hk-family-confirm-actions__cancel';
    cancelButton.textContent = admin?.text?.familyDuplicateCancel || 'Cancel';

    actions.appendChild(confirmButton);
    actions.appendChild(cancelButton);
    noticeContent.appendChild(actions);

    confirmButton.addEventListener('click', () => {
        hideFamilyFormNotice();
        onConfirm();
    });

    cancelButton.addEventListener('click', () => {
        hideFamilyFormNotice();
        onCancel();
    });
};

const getFamilyMemberFromResponse = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    if (payload.member && typeof payload.member === 'object') {
        return payload.member;
    }

    if (payload.Id || payload.FirstName || payload.LastName) {
        return payload;
    }

    return null;
};

const buildFamilyMemberFallback = (formData, memberId = '') => ({
    Id: memberId || '',
    FirstName: formData.get('FirstName') || '',
    LastName: formData.get('LastName') || '',
    HKN_NIF__c: formData.get('HKN_NIF__c') || '',
    Birthdate: formData.get('Birthdate') || '',
    Email: formData.get('family-member-email') || '',
    HKN_Gender__c: normalizeContactGenderValue(formData.get('HKN_Gender__c') || ''),
    HKN_PrefijoTelefono__c: formData.get('HKN_PrefijoTelefono__c') || '',
    Phone: formData.get('Phone') || '',
    HKN_GrupoEdad__c: formData.get('HKN_GrupoEdad__c') || '',
    HKN_Registrado_en_Portal__c: (formData.get('new_user') || 'no') === 'yes',
});

const formatFamilyBirthdate = (value) => {
    if (typeof value !== 'string' || value.trim() === '') {
        return '';
    }

    const dateValue = value.trim();
    const isoMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
        return `${isoMatch[3]}-${isoMatch[2]}-${isoMatch[1]}`;
    }

    const slashMatch = dateValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
        return `${slashMatch[1]}-${slashMatch[2]}-${slashMatch[3]}`;
    }

    return dateValue;
};

const hasFamilyWebAccess = (value) => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return value === 1;
    }
    const normalized = (value || '').toString().trim().toLowerCase();
    return ['1', 'true', 'yes', 'si', 'sí'].includes(normalized);
};

const normalizeContactGenderValue = (value) => {
    const rawValue = (value || '').toString().trim();
    const normalized = rawValue
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    if (!normalized) {
        return '';
    }
    if (['0', 'masculino', 'masculina', 'male', 'man', 'hombre', 'varon', 'chico'].includes(normalized)) {
        return '0';
    }
    if (['1', 'femenino', 'femenina', 'female', 'woman', 'mujer', 'chica'].includes(normalized)) {
        return '1';
    }
    return '';
};

const getFamilyMemberAge = (birthdateValue) => {
    const rawValue = (birthdateValue || '').toString().trim();
    if (!rawValue) {
        return null;
    }

    const birthdate = new Date(`${rawValue}T00:00:00`);
    if (Number.isNaN(birthdate.getTime())) {
        return null;
    }

    const today = new Date();
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDelta = today.getMonth() - birthdate.getMonth();
    if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthdate.getDate())) {
        age -= 1;
    }

    return age;
};

const getFamilyMemberActivityMissingFields = (member) => {
    const age = getFamilyMemberAge(member?.Birthdate || member?.BirthDate || '');
    if (typeof age !== 'number' || age < 18) {
        return [];
    }

    const missing = [];
    const email = (member?.Email || '').toString().trim();
    const nif = (member?.HKN_NIF__c || '').toString().trim();
    const gender = normalizeContactGenderValue(member?.HKN_Gender__c || '');
    const ageGroup = (member?.HKN_GrupoEdad__c || '').toString().trim();
    const phonePrefix = (member?.HKN_PrefijoTelefono__c || '').toString().trim();
    const phone = (member?.Phone || member?.HKN_Telefono_Persona__c || '').toString().trim();

    if (!email) missing.push('email');
    if (!nif) missing.push('identity_document');
    if (!gender) missing.push('gender');
    if (!ageGroup) missing.push('age_group');
    if (!phonePrefix) missing.push('phone_prefix');
    if (!phone) missing.push('phone');

    return missing;
};

const getFamilyMissingLabels = (keys) => {
    const labels = {
        email: admin?.text?.familyMissingEmail || 'correo',
        identity_document: admin?.text?.familyMissingIdentity || 'ID fiscal/nacional',
        gender: admin?.text?.familyMissingGender || 'sexo',
        age_group: admin?.text?.familyMissingAgeGroup || 'grupo de edad',
        phone_prefix: admin?.text?.familyMissingPhonePrefix || 'prefijo telefónico',
        phone: admin?.text?.familyMissingPhone || 'teléfono',
    };
    return (keys || []).map((key) => labels[key]).filter(Boolean);
};

const escapeHtmlAttr = (value) => {
    return (value || '').toString()
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

const formatFamilyBirthdateDisplay = (value) => {
    const formatted = formatFamilyBirthdate(value);
    if (!formatted) {
        return '';
    }
    return formatted.replace(/-/g, '/');
};

const getFamilyCardMarkup = (member) => {
    if (!member || typeof member !== 'object') {
        return '';
    }

    const memberId = (member.Id || '').toString().trim();
    if (!memberId) {
        return '';
    }

    const firstName = (member.FirstName || '').toString().trim();
    const lastName = (member.LastName || '').toString().trim();
    const fullName = `${firstName} ${lastName}`.trim() || (admin?.text?.familyMemberFallback || 'Family member');
    const birthdateRaw = (member.Birthdate || member.BirthDate || '').toString().trim();
    const birthdateLabel = formatFamilyBirthdateDisplay(birthdateRaw);
    const nif = (member.HKN_NIF__c || member.HKN_NIF__C || '').toString().trim();
    const email = (member.Email || '').toString().trim();
    const gender = normalizeContactGenderValue(member.HKN_Gender__c || '');
    const phonePrefix = (member.HKN_PrefijoTelefono__c || '').toString().trim();
    const phone = (member.Phone || member.HKN_Telefono_Persona__c || '').toString().trim();
    const ageGroup = (member.HKN_GrupoEdad__c || '').toString().trim();
    const hasWebAccess = hasFamilyWebAccess(member.HKN_Registrado_en_Portal__c);
    const age = getFamilyMemberAge(birthdateRaw);
    const isAdult = typeof age === 'number' && age >= 18;
    const missingFields = getFamilyMemberActivityMissingFields(member);
    const canCreateAccount = isAdult && !hasWebAccess;
    const missingStatus = missingFields.length > 0
        ? `${admin?.text?.familyIncompleteStatusPrefix || 'Faltan datos para actividades'}: ${getFamilyMissingLabels(missingFields).join(', ')}`
        : '';

    const metaParts = [];
    if (birthdateLabel) {
        metaParts.push(birthdateLabel);
    }
    if (nif) {
        metaParts.push(`${admin?.text?.familyIdentityLabel || 'ID fiscal/nacional'}: ${nif}`);
    }

    const contactParts = [];
    if (phonePrefix || phone) {
        contactParts.push([phonePrefix, phone].filter(Boolean).join(' ').trim());
    }
    if (email) {
        contactParts.push(email);
    }
    if (contactParts.length > 0) {
        metaParts.push(contactParts.join(' · '));
    }
    if (ageGroup) {
        metaParts.push(ageGroup);
    }

    const badges = [];
    if (!isAdult) {
        const minorLabel = escapeHtmlAttr(admin?.text?.familyMinorBadge || 'Menor de edad');
        badges.push(`<span class="hk-family-modal-member__minor-icon" role="img" aria-label="${minorLabel}" title="${minorLabel}"></span>`);
    }
    if (missingFields.length > 0) {
        badges.push(`<span class="hk-family-modal-member__badge hk-family-modal-member__badge--warning">${escapeHtmlAttr(admin?.text?.familyIncompleteBadge || 'Faltan datos para actividades')}</span>`);
    }
    if (canCreateAccount) {
        badges.push(`<span class="hk-family-modal-member__badge hk-family-modal-member__badge--info">${escapeHtmlAttr(admin?.text?.familyAdultAccountBadge || 'Ya puede tener cuenta propia')}</span>`);
    }

    const hints = [];
    if (missingFields.length > 0) {
        hints.push(`<p class="hk-family-modal-member__hint">${escapeHtmlAttr(missingStatus)}</p>`);
    }
    if (canCreateAccount) {
        hints.push(`<p class="hk-family-modal-member__hint">${escapeHtmlAttr(admin?.text?.familyAdultAccountHint || 'Si quieres, entra en Editar y añade su correo para enviarle el acceso a su cuenta.')}</p>`);
    }

    const actions = hasWebAccess
        ? `<span class="hk-family-modal-member__state">${escapeHtmlAttr(admin?.text?.familyOwnAccount || 'Cuenta web propia')}</span>`
        : [
            `<button type="button" class="button hk-family-modal-member__icon-button hk-family-modal-member__icon-button--edit" data-family-action="edit" data-member-id="${escapeHtmlAttr(memberId)}" aria-label="${escapeHtmlAttr(admin?.text?.familyEditAction || 'Editar')}" title="${escapeHtmlAttr(admin?.text?.familyEditFamilyTitle || 'Editar familiar')}">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20h4.5L19 9.5 14.5 5 4 15.5V20Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12.5 7 17 11.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            </button>`,
            `<button type="button" class="button hk-family-modal-member__icon-button hk-family-modal-member__icon-button--delete" data-family-action="delete" data-member-id="${escapeHtmlAttr(memberId)}" aria-label="${escapeHtmlAttr(admin?.text?.familyDeleteAction || 'Eliminar')}" title="${escapeHtmlAttr(admin?.text?.familyDeleteFamilyTitle || 'Eliminar familiar')}">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 8 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M16 8 8 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>
            </button>`,
        ].join('');

    const cardClasses = ['hk-family-modal-member', isAdult ? 'hk-family-modal-member--adult' : 'hk-family-modal-member--minor'];
    if (missingFields.length > 0) {
        cardClasses.push('hk-family-modal-member--incomplete');
    }
    if (hasWebAccess) {
        cardClasses.push('hk-family-modal-member--locked');
    }

    return `
        <article class="${cardClasses.join(' ')}" data-family-member-id="${escapeHtmlAttr(memberId)}" data-family-first-name="${escapeHtmlAttr(firstName)}" data-family-last-name="${escapeHtmlAttr(lastName)}" data-family-nif="${escapeHtmlAttr(nif)}" data-family-birthdate="${escapeHtmlAttr(birthdateRaw)}" data-family-email="${escapeHtmlAttr(email)}" data-family-gender="${escapeHtmlAttr(gender)}" data-family-phone-prefix="${escapeHtmlAttr(phonePrefix)}" data-family-phone="${escapeHtmlAttr(phone)}" data-family-age-group="${escapeHtmlAttr(ageGroup)}" data-family-web-access="${hasWebAccess ? '1' : '0'}" data-family-is-adult="${isAdult ? '1' : '0'}" data-family-needs-activity-completion="${missingFields.length > 0 ? '1' : '0'}" data-family-can-create-account="${canCreateAccount ? '1' : '0'}" data-family-missing-status="${escapeHtmlAttr(missingStatus)}" data-family-group="${isAdult ? 'adult' : 'minor'}">
            <div class="hk-family-modal-member__main">
                <p class="hk-family-modal-member__name">${escapeHtmlAttr(fullName)}</p>
                ${metaParts.length > 0 ? `<p class="hk-family-modal-member__meta">${escapeHtmlAttr(metaParts.join(' · '))}</p>` : ''}
                ${badges.length > 0 ? `<div class="hk-family-modal-member__badges">${badges.join('')}</div>` : ''}
                ${hints.join('')}
            </div>
            <div class="hk-family-modal-member__actions">
                ${actions}
            </div>
        </article>
    `.trim();
};

const getFamilyBoard = () => document.querySelector('[data-family-members-board]') || document.getElementById('family-members');

const getFamilyGroupCardsContainer = (group) => {
    const board = getFamilyBoard();
    if (!board) {
        return null;
    }
    return board.querySelector(`[data-family-group-cards="${group}"]`);
};

const getFamilyGroupEmptyNode = (group) => {
    const board = getFamilyBoard();
    if (!board) {
        return null;
    }
    return board.querySelector(`[data-family-group-empty="${group}"]`);
};

const getFamilyEmptyStateLabel = (group) => {
    const board = getFamilyBoard();
    if (!board) {
        return admin?.text?.familyNoMembers || 'No hay familiares registrados';
    }

    const boardLabel = (board.dataset[`familyEmpty${group === 'adult' ? 'Adult' : 'Minor'}Label`] || '').toString().trim();
    if (boardLabel) {
        return boardLabel;
    }

    const existingEmptyNode = board.querySelector(`[data-family-group-empty="${group}"]`);
    const existingLabel = (existingEmptyNode?.textContent || '').toString().trim();
    if (existingLabel) {
        return existingLabel;
    }

    if (group === 'adult') {
        return admin?.text?.familyEmptyAdults || 'Todavía no tienes mayores de edad guardados.';
    }

    return admin?.text?.familyEmptyMinors || 'Todavía no tienes menores de edad guardados.';
};

const createFamilyGroupEmptyNode = (group) => {
    const emptyNode = document.createElement('div');
    emptyNode.className = 'family-members-group__empty';
    emptyNode.dataset.familyGroupEmpty = group;
    emptyNode.textContent = getFamilyEmptyStateLabel(group);
    return emptyNode;
};

const ensureFamilyGroupEmptyState = (group) => {
    const cardsContainer = getFamilyGroupCardsContainer(group);
    if (!cardsContainer) {
        return;
    }

    let emptyNode = getFamilyGroupEmptyNode(group);
    const hasCards = !!cardsContainer && cardsContainer.querySelector('[data-family-member-id]');
    if (!emptyNode) {
        emptyNode = createFamilyGroupEmptyNode(group);
        cardsContainer.appendChild(emptyNode);
    }

    emptyNode.hidden = hasCards;
};

const ensureFamilyEmptyState = () => {
    ensureFamilyGroupEmptyState('adult');
    ensureFamilyGroupEmptyState('minor');
};

const normalizeFamilyFullNameKey = (firstName, lastName) => {
    const value = `${firstName || ''} ${lastName || ''}`.trim();
    if (!value) {
        return '';
    }
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
};

const getDuplicateFamilyNameMessage = (firstName, lastName) => {
    const name = `${firstName || ''} ${lastName || ''}`.trim();
    return name
        ? `Ya existe un miembro de tu familia con el nombre "${name}". Revisa su ficha antes de crear otro familiar.`
        : 'Ya existe un miembro de tu familia con ese nombre. Revisa su ficha antes de crear otro familiar.';
};

const hasExistingFamilyFullName = (firstName, lastName, excludeMemberId = '') => {
    const targetKey = normalizeFamilyFullNameKey(firstName, lastName);
    const excludedId = (excludeMemberId || '').toString().trim();
    const board = getFamilyBoard();
    if (!targetKey || !board) {
        return false;
    }

    return Array.from(board.querySelectorAll('[data-family-member-id]')).some((card) => {
        const memberId = (card.dataset.familyMemberId || '').toString().trim();
        if (!memberId || (excludedId && memberId === excludedId)) {
            return false;
        }
        return normalizeFamilyFullNameKey(card.dataset.familyFirstName || '', card.dataset.familyLastName || '') === targetKey;
    });
};

const getFamilyDeleteConfirmText = () => {
    const htmlLang = (document.documentElement?.lang || '').toString().trim().toLowerCase();
    const isSpanishUI = htmlLang.startsWith('es');
    if (isSpanishUI) {
        return '¿Seguro que quieres eliminar este miembro de la familia?';
    }
    return admin?.text?.familyDeleteConfirm || '¿Seguro que quieres eliminar este miembro de la familia?';
};

const removeFamilyMemberCard = (memberId) => {
    if (!memberId) {
        return;
    }

    const board = getFamilyBoard();
    if (!board) {
        return;
    }

    const card = board.querySelector(`[data-family-member-id="${memberId}"]`);
    if (card) {
        card.remove();
    }
    ensureFamilyEmptyState();
};

const setFamilyFormMode = (mode, member = null) => {
    const memberForm = document.getElementById('family-form');
    if (!memberForm) {
        return;
    }

    const title = document.getElementById('family-form-title');
    const memberIdInput = document.getElementById('family-member-id');
    const firstNameInput = document.getElementById('FirstName');
    const lastNameInput = document.getElementById('LastName');
    const nifInput = document.getElementById('HKN_NIF__c');
    const birthdateInput = document.getElementById('Birthdate');
    const emailInput = document.getElementById('family-member-email');
    const genderInput = document.getElementById('family-member-gender');
    const phonePrefixInput = document.getElementById('family-member-phone-prefix');
    const phoneInput = document.getElementById('family-member-phone');
    const ageGroupInput = document.getElementById('family-member-age-group');
    const webAccessToggle = document.getElementById('family-new-user-toggle');
    const updateWebAccess = memberForm._hkUpdateFamilyWebAccess;

    const labels = admin?.text || {};
    const addTitle = labels.familyAddTitle || 'Add new family member';
    const editTitle = labels.familyEditTitle || 'Edit family member';
    const addSubmit = labels.familyAddSubmit || 'Add member';
    const editSubmit = labels.familyEditSubmit || 'Save member';

    if (mode === 'edit' && member) {
        if (title) {
            title.classList.remove('is-add');
            title.classList.add('is-edit');
            title.textContent = editTitle;
        }
        if (memberIdInput) {
            memberIdInput.value = member.id || '';
        }
        if (firstNameInput) {
            firstNameInput.value = member.firstName || '';
        }
        if (lastNameInput) {
            lastNameInput.value = member.lastName || '';
        }
        if (nifInput) {
            nifInput.value = member.nif || '';
        }
        if (birthdateInput) {
            birthdateInput.value = member.birthdate || '';
        }
        if (emailInput) {
            emailInput.value = member.email || '';
        }
        if (genderInput) {
            genderInput.value = normalizeContactGenderValue(member.gender || '');
        }
        if (phonePrefixInput) {
            phonePrefixInput.value = member.phonePrefix || '';
        }
        if (phoneInput) {
            phoneInput.value = member.phone || '';
        }
        if (ageGroupInput) {
            ageGroupInput.value = member.ageGroup || '';
        }
        if (webAccessToggle) {
            const hasWebAccess = hasFamilyWebAccess(member.webAccess || '0');
            webAccessToggle.checked = hasWebAccess;
            webAccessToggle.disabled = hasWebAccess;
        }
        if (typeof updateWebAccess === 'function') {
            updateWebAccess();
        }
        setFamilySubmitButtonText(editSubmit);
        setFamilyCancelEditVisibility(true);
        return;
    }

    if (title) {
        title.classList.remove('is-edit');
        title.classList.add('is-add');
        title.textContent = addTitle;
    }
    if (memberIdInput) {
        memberIdInput.value = '';
    }
    memberForm.reset();
    if (webAccessToggle) {
        webAccessToggle.disabled = false;
        webAccessToggle.checked = false;
    }
    if (typeof updateWebAccess === 'function') {
        updateWebAccess();
    }
    setFamilySubmitButtonText(addSubmit);
    setFamilyCancelEditVisibility(false);
};

const upsertFamilyMemberCard = (member) => {
    if (!member || typeof member !== 'object') {
        return;
    }

    const board = getFamilyBoard();
    if (!board) {
        return;
    }

    const memberId = (member.Id || '').toString().trim();
    if (!memberId) {
        return;
    }

    const memberAge = getFamilyMemberAge(member.Birthdate || member.BirthDate || '');
    const targetGroup = typeof memberAge === 'number' && memberAge >= 18 ? 'adult' : 'minor';
    const targetContainer = getFamilyGroupCardsContainer(targetGroup);
    if (!targetContainer) {
        return;
    }

    const cardMarkup = getFamilyCardMarkup(member);
    if (!cardMarkup) {
        return;
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = cardMarkup;
    const newCard = wrapper.firstElementChild;
    if (!newCard) {
        return;
    }

    const existingCard = board.querySelector(`[data-family-member-id="${memberId}"]`);
    if (existingCard) {
        const existingGroup = existingCard.dataset.familyGroup || '';
        if (existingGroup === targetGroup && existingCard.parentElement === targetContainer) {
            existingCard.replaceWith(newCard);
        } else {
            existingCard.remove();
            targetContainer.appendChild(newCard);
        }
    } else {
        targetContainer.appendChild(newCard);
    }

    ensureFamilyEmptyState();
};

const resetFamilyForm = () => {
    setFamilyFormMode('create');
};

const openFamilyFormPanel = () => {
    const panel = document.getElementById('family-member-form-panel');
    const familyFormTrigger = document.querySelector('.family-member-add-trigger[data-display="family-member-form-panel"]');

    if (familyFormTrigger && !familyFormTrigger.classList.contains('open')) {
        familyFormTrigger.click();
    }

    if (panel) {
        panel.style.visibility = 'visible';
        panel.style.height = 'auto';
    }

    return panel;
};

const scrollFamilyNodeIntoView = (node) => {
    if (!node || typeof node.scrollIntoView !== 'function') {
        return;
    }
    window.requestAnimationFrame(() => {
        node.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
};

const familyForm = () => {
    const memberForm = document.getElementById('family-form');
    if (memberForm) {
        setFamilyFormMode('create');

        const cancelEditButton = document.getElementById('family-cancel-edit');
        if (cancelEditButton && cancelEditButton.dataset.hkFamilyCancelEditBound !== '1') {
            cancelEditButton.dataset.hkFamilyCancelEditBound = '1';
            cancelEditButton.addEventListener('click', () => {
                resetFamilyForm();
            });
        }

        ensureFamilyEmptyState();

        const familyBoard = getFamilyBoard();
        if (familyBoard && familyBoard.dataset.hkFamilyBoardBound !== '1') {
            familyBoard.dataset.hkFamilyBoardBound = '1';
            familyBoard.addEventListener('click', (event) => {
                const actionButton = event.target.closest('[data-family-action]');
                if (!actionButton) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();

                const action = actionButton.dataset.familyAction || '';
                const card = actionButton.closest('[data-family-member-id]');
                const memberId = card?.dataset.familyMemberId || '';
                if (!card || !memberId) {
                    return;
                }

                const hasWebAccess = hasFamilyWebAccess(card.dataset.familyWebAccess || '0');
                if (hasWebAccess) {
                    return;
                }

                if (action === 'edit') {
                    openFamilyFormPanel();
                    setFamilyFormMode('edit', {
                        id: memberId,
                        firstName: card.dataset.familyFirstName || '',
                        lastName: card.dataset.familyLastName || '',
                        nif: card.dataset.familyNif || '',
                        birthdate: card.dataset.familyBirthdate || '',
                        email: card.dataset.familyEmail || '',
                        gender: normalizeContactGenderValue(card.dataset.familyGender || ''),
                        phonePrefix: card.dataset.familyPhonePrefix || '',
                        phone: card.dataset.familyPhone || '',
                        ageGroup: card.dataset.familyAgeGroup || '',
                        webAccess: card.dataset.familyWebAccess || '0',
                    });
                    return;
                }

                if (action === 'delete') {
                    openFamilyFormPanel();
                    const confirmText = getFamilyDeleteConfirmText();
                    showFamilyFormNotice(confirmText, 'duplicate');
                    const errorNotice = document.getElementById('error-notice');
                    scrollFamilyNodeIntoView(errorNotice);
                    const noticeContent = errorNotice ? errorNotice.querySelector('.notice-content') : null;
                    if (!noticeContent) { return; }

                    const actions = document.createElement('div');
                    actions.className = 'family-duplicate-actions';
                    const acceptBtn = document.createElement('button');
                    acceptBtn.type = 'button';
                    acceptBtn.className = 'button button-primary family-duplicate-action family-duplicate-action--confirm';
                    acceptBtn.textContent = admin?.text?.familyDeleteAccept || 'Sí, eliminar';
                    const cancelBtn = document.createElement('button');
                    cancelBtn.type = 'button';
                    cancelBtn.className = 'button family-duplicate-action family-duplicate-action--cancel';
                    cancelBtn.textContent = admin?.text?.familyDeleteCancel || 'No, volver';
                    actions.appendChild(acceptBtn);
                    actions.appendChild(cancelBtn);
                    noticeContent.appendChild(actions);

                    cancelBtn.addEventListener('click', () => { hideFamilyFormNotice(); });
                    acceptBtn.addEventListener('click', () => {
                        if (acceptBtn.dataset.processing === '1') {
                            return;
                        }
                        acceptBtn.dataset.processing = '1';
                        acceptBtn.disabled = true;
                        cancelBtn.disabled = true;
                        hideFamilyFormNotice();
                        const nonceInput = memberForm.querySelector('input[name="_wpnonce"]');
                        const accountInput = memberForm.querySelector('input[name="AccountId"]');
                        const requestData = new FormData();
                        requestData.append('action', 'sf_delete_family_member');
                        requestData.append('memberId', memberId);
                        requestData.append('AccountId', accountInput ? accountInput.value : '');
                        if (nonceInput) {
                            requestData.append('_wpnonce', nonceInput.value);
                        }

                        fetch(admin.ajax_url, {
                            method: 'POST',
                            body: requestData,
                        })
                        .then((response) => response.json())
                        .then((result) => {
                            if (!result.success) {
                                trackProfileAction('family_delete', 'ko');
                                showFamilyFormError(result?.data?.message || 'No se pudo eliminar. Inténtalo de nuevo.');
                                acceptBtn.dataset.processing = '0';
                                acceptBtn.disabled = false;
                                cancelBtn.disabled = false;
                                return;
                            }
                            trackProfileAction('family_delete', 'ok');
                            removeFamilyMemberCard(memberId);
                            notifyFamilyMembersUpdated();
                            const editingMemberId = (document.getElementById('family-member-id')?.value || '').trim();
                            if (editingMemberId === memberId) {
                                resetFamilyForm();
                            }
                        })
                        .catch((error) => {
                            trackProfileAction('family_delete', 'ko', { via: 'network' });
                            console.error('Error en sf_delete_family_member:', error);
                            showFamilyFormError('Ha ocurrido un error al eliminar. Comprueba tu conexión e inténtalo de nuevo.');
                            acceptBtn.dataset.processing = '0';
                            acceptBtn.disabled = false;
                            cancelBtn.disabled = false;
                        });
                    });
                }
            });
        }

        if (memberForm.dataset.hkFamilySubmitBound === '1') {
            return;
        }
        memberForm.dataset.hkFamilySubmitBound = '1';

        memberForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const formData = new FormData(memberForm);
            formData.set('HKN_Gender__c', normalizeContactGenderValue(formData.get('HKN_Gender__c') || ''));
            const memberIdInput = document.getElementById('family-member-id');
            const editingMemberId = memberIdInput ? memberIdInput.value.trim() : '';
            const isEditing = editingMemberId !== '';

            const submittedFirstName = (formData.get('FirstName') || '').toString().trim();
            const submittedLastName = (formData.get('LastName') || '').toString().trim();
            if (hasExistingFamilyFullName(submittedFirstName, submittedLastName, editingMemberId)) {
                showFamilyFormError(getDuplicateFamilyNameMessage(submittedFirstName, submittedLastName));
                scrollFamilyNodeIntoView(document.getElementById('error-notice'));
                return;
            }

            if (isEditing) {
                formData.set('action', 'sf_update_family_member');
                formData.set('memberId', editingMemberId);
            } else {
                formData.set('action', 'sf_register_family_member');
            }

            const fallbackMember = buildFamilyMemberFallback(formData, editingMemberId);
            hideFamilyFormNotice();
            const submitButton = document.getElementById('submit-family');
            if (submitButton) {
                submitButton.disabled = true;
                // Guardamos el texto original para restaurarlo después
                const originalText = submitButton.value || submitButton.innerText;
                submitButton.dataset.originalText = originalText;

                const originalBackground = submitButton.style.backgroundColor;
                submitButton.dataset.originalBackground = originalBackground;

                submitButton.style.background = 'gray';

                if (submitButton.tagName.toLowerCase() === 'input') {
                    submitButton.value = 'Procesando...';
                    submitButton.style.backGroundColor
                } else {
                    submitButton.innerText = 'Procesando...';
                }
            }

            fetch(admin.ajax_url, {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then( result => {
                if( !result.success ) {
                    if (!isEditing && result?.data?.flag === 'duplicate') {
                        showFamilyDuplicateNotice(
                            result?.data?.message,
                            () => {
                                const duplicateMemberId = result?.data?.memberId || '';
                                const duplicateFallback = buildFamilyMemberFallback(formData, duplicateMemberId);
                                enviarPeticion(result.data.AccountId, duplicateMemberId, duplicateFallback);
                            },
                            () => {
                                restoreFamilySubmitButton();
                            }
                        );
                        return;
                    }

                    // Apellido del menor no coincide con ningún adulto:
                    // ofrecemos solicitar revisión. El segundo POST crea o
                    // reutiliza el Contact, pero no lo asocia a la familia.
                    if (!isEditing && result?.data?.flag === 'family_surname_warning') {
                        showFamilySurnameReviewNotice(
                            result?.data?.message,
                            () => {
                                hideFamilyFormNotice();
                                restoreFamilySubmitButton();
                                ensureFamilySurnameReviewRequestInput(memberForm, true);
                                if (typeof memberForm.requestSubmit === 'function') {
                                    memberForm.requestSubmit();
                                } else {
                                    memberForm.dispatchEvent(new Event('submit', { cancelable: true }));
                                }
                            },
                            () => {
                                ensureFamilySurnameReviewRequestInput(memberForm, false);
                                restoreFamilySubmitButton();
                            }
                        );
                        return;
                    }

                    // Cualquier otro error: limpiamos una eventual solicitud
                    // colgada de un intento anterior para no bypassear la
                    // validación en el siguiente alta.
                    ensureFamilySurnameReviewRequestInput(memberForm, false);
                    trackProfileAction(isEditing ? 'family_update' : 'family_add', 'ko');
                    showFamilyFormError(result?.data?.message);
                    restoreFamilySubmitButton();
                    return;
                }

                if (!isEditing && result?.data?.flag === 'pending_family_review') {
                    trackProfileAction('family_add', 'pending_review');
                    if (window.dataLayer && Array.isArray(window.dataLayer)) {
                        window.dataLayer.push({
                            event: 'family_review_requested',
                            comp_core: { via: 'mi_perfil' },
                        });
                    }
                    resetFamilyForm();
                    ensureFamilySurnameReviewRequestInput(memberForm, false);
                    restoreFamilySubmitButton();
                    showFamilyFormNotice(result?.data?.message, 'duplicate');
                    return;
                }

                const memberFromResult = getFamilyMemberFromResponse(result?.data);
                trackProfileAction(isEditing ? 'family_update' : 'family_add', 'ok');
                upsertFamilyMemberCard(memberFromResult || fallbackMember);
                notifyFamilyMembersUpdated();
                resetFamilyForm();
                ensureFamilySurnameReviewRequestInput(memberForm, false);
                restoreFamilySubmitButton();
            })
            .catch((error) => {
                ensureFamilySurnameReviewRequestInput(memberForm, false);
                trackProfileAction(isEditing ? 'family_update' : 'family_add', 'ko', { via: 'network' });
                console.error('Error en sf_add_family_member:', error);
                showFamilyFormError('Ha ocurrido un error al añadir el miembro de familia.');
                restoreFamilySubmitButton();
            })
        });
    }
};

// Inyecta la solicitud de revisión en el segundo POST. No es un override:
// el backend nunca asociará automáticamente a la persona con ese flag.
const ensureFamilySurnameReviewRequestInput = (form, enabled) => {
    if (!form) return;
    let input = form.querySelector('input[name="family_surname_review_request"]');
    if (enabled) {
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'family_surname_review_request';
            form.appendChild(input);
        }
        input.value = '1';
    } else if (input) {
        input.remove();
    }
};

const showFamilySurnameReviewNotice = (message, onConfirm, onCancel) => {
    const errorNotice = document.getElementById('error-notice');
    const noticeContent = errorNotice ? errorNotice.querySelector('.notice-content') : null;
    const isSpanish = (document.documentElement?.lang || '').toLowerCase().startsWith('es');
    const fallbackMessage = isSpanish
        ? 'El apellido no coincide con ningún adulto de tu familia. Si los datos son correctos, solicita que el equipo de Hakuna lo revise.'
        : 'The surname does not match any adult in your family. If the details are correct, ask the Hakuna team to review it.';
    const text = (typeof message === 'string' && message.trim() !== '') ? message : fallbackMessage;

    showFamilyFormNotice(text, 'duplicate');

    if (!noticeContent) {
        onCancel();
        return;
    }

    const actions = document.createElement('div');
    actions.className = 'family-duplicate-actions family-surname-review-actions hk-family-confirm-actions';

    const label = document.createElement('label');
    label.className = 'family-surname-review-confirm';
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = '1';
    const labelText = document.createElement('span');
    labelText.textContent = isSpanish
        ? 'Solicito añadir esta persona a mi familia aunque el apellido no coincida.'
        : 'I request to add this person to my family even though the surname does not match.';
    label.appendChild(checkbox);
    label.appendChild(labelText);

    const confirmButton = document.createElement('button');
    confirmButton.type = 'button';
    confirmButton.className = 'button button-primary family-duplicate-action family-duplicate-action--confirm hk-family-confirm-actions__accept';
    confirmButton.textContent = isSpanish ? 'Solicitar añadir familiar' : 'Request family member review';
    confirmButton.disabled = true;

    const cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.className = 'button family-duplicate-action family-duplicate-action--cancel hk-family-confirm-actions__cancel';
    cancelButton.textContent = isSpanish ? 'Revisar apellido' : 'Check surname';

    checkbox.addEventListener('change', () => {
        confirmButton.disabled = !checkbox.checked;
    });

    actions.appendChild(label);
    actions.appendChild(confirmButton);
    actions.appendChild(cancelButton);
    noticeContent.appendChild(actions);

    const memberForm = document.getElementById('family-form');

    confirmButton.addEventListener('click', () => {
        if (!checkbox.checked) {
            return;
        }
        ensureFamilySurnameReviewRequestInput(memberForm, true);
        onConfirm();
    });

    cancelButton.addEventListener('click', () => {
        ensureFamilySurnameReviewRequestInput(memberForm, false);
        hideFamilyFormNotice();
        onCancel();
    });
};

async function enviarPeticion(AccountId, memberId, fallbackMember = null) {
    const memberForm = document.getElementById('family-form');
    if (!memberForm) {
        restoreFamilySubmitButton();
        return;
    }

    const nifInput = memberForm.querySelector('#HKN_NIF__c');
    const nif = nifInput ? nifInput.value : '';
    const formData = new FormData(memberForm);
    formData.set('HKN_Gender__c', normalizeContactGenderValue(formData.get('HKN_Gender__c') || ''));
    formData.set('action', 'sf_change_family_member');
    formData.set('AccountId', AccountId);
    formData.set('memberId', memberId);
    formData.set('nif', nif);
    await fetch(admin.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
    })
    .then(response => response.json())
    .then( result => {
        if( !result.success ) {
            trackProfileAction('family_link', 'ko');
            showFamilyFormError(result?.data?.message);
            restoreFamilySubmitButton();
            return;
        }

        const memberFromResult = getFamilyMemberFromResponse(result?.data);
        trackProfileAction('family_link', 'ok');
        upsertFamilyMemberCard(memberFromResult || fallbackMember);
        notifyFamilyMembersUpdated();
        resetFamilyForm();
        restoreFamilySubmitButton();
    })
    .catch((error) => {
        trackProfileAction('family_link', 'ko', { via: 'network' });
        console.error('Error en sf_change_family_member:', error);
        showFamilyFormError('Ha ocurrido un error al asociar el miembro existente.');
        restoreFamilySubmitButton();
    })
}

const goToTab = () => {
    const params = new URLSearchParams(window.location.search);
    const requestedRaw = (params.get('hk_subpage') || params.get('subpage') || params.get('tab') || '').trim();
    if (!requestedRaw) return;

    const aliases = {
        'personal-data': 'datos-personales',
        'suscriptions': 'suscripciones',
        'subscriptions': 'suscripciones',
        'inscriptions': 'inscripciones',
        'donations': 'donaciones',
        'sugestions': 'sugerencias',
        'suggestions': 'sugerencias',
    };
    const tab = aliases[requestedRaw] || requestedRaw;
    const profileMenu = document.querySelector('.subpages-menu[data-subpage-scope="perfil"]');
    if (!profileMenu) return;

    const menuItems = [...profileMenu.querySelectorAll('.subpages-menu__item')];
    if (!menuItems.length) return;

    // Tabs permitidos = los del menú
    const allowedTabs = menuItems.map(i => i.dataset.subpage).filter(Boolean);

    if (!allowedTabs.includes(tab)) return;

    // Solo contenidos del scope "perfil"
    const contents = [...document.querySelectorAll('.subpage-content[data-subpage-scope="perfil"]')]
        .filter(content => {
            const key = content.dataset.subpageContent || content.id || '';
            return allowedTabs.includes(key);
        });

    // Reset SOLO de los tabs conocidos
    menuItems.forEach(i => i.classList.remove('active'));
    contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
    });

    // Activar el elegido
    const activeLink = menuItems.find(i => i.dataset.subpage === tab);
    const activeContent = contents.find(content => (content.dataset.subpageContent || content.id || '') === tab);

    if (activeLink) activeLink.classList.add('active');
    if (activeContent) {
        activeContent.classList.add('active');
        activeContent.style.display = '';
    }
};

const payOutstandingPayments = () => {
    const buttons = document.querySelectorAll('[data-hk-pending-payment-btn="1"]');
    if (!buttons.length) return;

    buttons.forEach((pay) => {
        if (!pay || pay.dataset.hkPendingPaymentBound === '1') {
            return;
        }
        pay.dataset.hkPendingPaymentBound = '1';
        let isRunning = false;

        pay.addEventListener('click', function (e) {
            e.preventDefault();
            if (isRunning) {
                return;
            }
            isRunning = true;

            const originalText = this.textContent;
            const originalColor = this.style.color;
            const originalPointer = this.style.pointerEvents;

            this.textContent = 'Procesando...';
            this.style.color = '#999';
            this.style.pointerEvents = 'none';

            this.classList.add('is-disabled');
            this.setAttribute('aria-disabled', 'true');
            this.style.pointerEvents = 'none';

            const userAccountId= this.dataset.id;
            const nonce= this.dataset.nonce;
            const amount= this.dataset.amount;
            const payId= this.dataset.payid;

            if (!userAccountId || !nonce) {
                console.error('Falta data-id o data-nonce');
                this.classList.remove('is-disabled');
                this.removeAttribute('aria-disabled');
                this.style.pointerEvents = '';
                isRunning = false;
                return;
            }
            const pendingPaymentForm = new FormData();
            pendingPaymentForm.append('action', admin.actionPendingPayments);
            pendingPaymentForm.append('nonce', admin.noncePendingPayments);
            pendingPaymentForm.append('userAccountId', userAccountId);
            pendingPaymentForm.append('url_callback', window.location.href);
            pendingPaymentForm.append('amount', amount);
            pendingPaymentForm.append('payId', payId);

            const restoreBtn = () => {
                this.textContent = originalText;
                this.style.color = originalColor;
                this.style.pointerEvents = originalPointer;
                this.classList.remove('is-disabled');
                this.removeAttribute('aria-disabled');
                this.style.pointerEvents = '';
                isRunning = false;
            };

            fetch(admin.ajax_url, {
                method: 'POST',
                body: pendingPaymentForm,
            })
                .then( response => response.json())
                .then( result => {
                    // Caso A: link Paymatico recibido → redirección
                    if (result && typeof result.success === 'string' && result.success.startsWith('http')) {
                        trackProfileAction('pending_payment', 'ok', {
                            profile_section: 'inscripciones',
                            payment_status: 'redirect',
                        });
                        window.location.href = result.success;
                        return;
                    }
                    // Caso B: la persona ya no debe nada (Status pasado a "al día")
                    if (result && result.no_morosidad) {
                        trackProfileAction('pending_payment', 'ok', {
                            profile_section: 'inscripciones',
                            payment_status: 'no_pending',
                        });
                        const notice = this.closest('.hk-morosidad-notice');
                        if (notice) {
                            notice.classList.add('hk-morosidad-notice--cleared');
                            notice.innerHTML = '<div class="hk-morosidad-notice__main"><div class="hk-morosidad-notice__icon" aria-hidden="true">✓</div><div class="hk-morosidad-notice__content"><h3 class="hk-morosidad-notice__title">¡Estás al día, gracias!</h3><p class="hk-morosidad-notice__text">' + (result.message || 'No tienes ningún pago de morosidad pendiente.') + '</p></div></div>';
                        } else if (typeof showUpdateErrorNotice === 'function') {
                            showUpdateErrorNotice(result.message || '¡Estás al día!');
                        }
                        restoreBtn();
                        return;
                    }
                    // Caso C: error genérico
                    const msg = (result && (result.data && result.data.message || result.message)) || 'Ha ocurrido un error al procesar el pago pendiente.';
                    trackProfileAction('pending_payment', 'ko', {
                        profile_section: 'inscripciones',
                    });
                    showUpdateErrorNotice(msg);
                    restoreBtn();
                })
                .catch(error => {
                    trackProfileAction('pending_payment', 'ko', {
                        profile_section: 'inscripciones',
                        via: 'network',
                    });
                    console.error('Error en la petición AJAX de pago pendiente:', error);
                    restoreBtn();
                });
        });
    });
};
